<template>
  <Layout>
    <div class="box_video">
      <el-row :gutter="24">
        <el-col :offset="3" :xs="17" :sm="17" :md="17" :lg="17" :xl="17">
          <div class="box_curriculum_title_1" v-if="location === 'center' ">
            当前位置 : <span style="color: #9EA4AA">首页 / 个人中心 / </span><span>我的课程</span>
          </div>
          <div class="box_curriculum_title_1" v-if="location === 'shou' ">
            当前位置 : <span>首页</span>
          </div>
          <div class="box_curriculum_title_1" v-if="location === 'fen' ">
            当前位置 : <span style="color: #9EA4AA">首页 / </span><span>公需课</span>
          </div>
          <div class="box_video_file">
            <!-- <div class="box_video_shi" v-loading="jiazai" v-if="info.courseType==1">
              <iframe allowfullscreen :src="iframeUrl" width="888" height="500" name="test" frameborder="0" align="left"
                scrolling="no"></iframe>
            </div> -->
            <div class="video-wrapper bg-gray-400" id="dplayer"></div>
            <div class="box_video_jian">
              <div class="box_video_mulu" style="margin-top:0px">
                <div v-for="(item,index) in videoCatalogue" :key="index">
                  <div v-if="(index==0||(item.courseId!=videoCatalogue[index-1].courseId))&&item.courseName"
                    style='font-weight: 700;line-height: 40px;padding-left:10px;text-align: center;'>
                    课程:{{item.courseName}}
                  </div>
                  <div v-if="(index==0||(item.numberCode!=videoCatalogue[index-1].numberCode))&&item.chapterName"
                    style='font-weight: 700;line-height: 40px;padding-left:10px'>
                    {{item.chapterName}}
                  </div>
                  <div class="box_video_mulu_1 xuanfu" :class="index==selecIndex ? 'selected' : '' ">
                    <div class="box_video_mulu_file" :title="item.sectionName" @click="handleNodeClickTwo(item,index)">
                      <div>{{item.sectionName}}</div>
                      <div>
                        <el-progress :width="30" type="circle" :percentage="item.percentage|upnum"></el-progress>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div style="height:200px;"></div>
          <div class="box_video_mulu" v-if="0">
            <div v-for="(item,index) in videoCatalogue" :key="index">
              <div v-if="(index==0||(item.numberCode!=videoCatalogue[index-1].numberCode))&&item.chapterName"
                style='font-weight: 700;line-height: 40px;padding-left:10px'>
                {{item.chapterName}}
              </div>
              <div class="box_video_mulu_1 xuanfu" :class="index==selecIndex ? 'selected' : '' ">
                <div class="box_video_mulu_file" :title="item.sectionName" @click="handleNodeClickTwo(item,index)">
                  <div>{{item.sectionName}}</div>
                  <div>
                    <el-progress :width="30" type="circle" :percentage="item.percentage|upnum"></el-progress>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </Layout>
</template>

<script>
import { selecVideoList, selecVideoListByMajorId, getPlayInfo, courseById, saveQJ } from "@/api/information"
import { setToken, getToken, removeToken } from "@/util/js-cookie"
import Layout from "@/views/gaiban/public/layout.vue"
import { CIDEOURL } from "@/util/video"
import { listDictByUser } from "@/api/home"
import DPlayer from 'dplayer';
export default {
  components: {
    Layout
  },
  filters: {
    upnum (num) {
      if (num >= 99) {
        return 100
      } else {
        return num
      }
    }
  },
  data () {
    return {
      info: {
        courseType: 2,
      },
      // 选中
      selecIndex: 0,

      // 视频连接
      iframeUrl: "",
      // 课程名称
      className: "",
      // 课程id
      classid: "",
      // 课程目录
      videoCatalogue: [],
      // 加载
      jiazai: false,
      // 位置
      location: "",
      dp: '',
      timer: null,
    }
  },
  beforeDestroy () {
    console.log(111)
    this.saveQJ(1)
  },
  methods: {
    // 点击目录
    handleNodeClickTwo (item, index) {
      if (index !== this.selecIndex) {
        this.saveQJ()

      }

      this.selecIndex = index;
      setTimeout(() => {
        this.jiazai = true
      }, 500);

      setTimeout(() => {
        this.jiazai = false
      }, 2500);
      this.shiping(item.sectionId, item.percentage, item)
    },
    open (chapterName, courseId) {
      selecVideoListByMajorId(courseId).then(res => {
        if (res.data.success === true) {
          this.videoCatalogue = res.data.data;
          // 默认播放第一小节
          // console.log("!!!!!!!!!!!!!!!!")
          let videoCatalogueinfo = ''
          this.videoCatalogue.forEach((item, index) => {
            if (item.learnedLast == 'Y') {
              this.selecIndex = index
              videoCatalogueinfo = item
            }
          })
          if (videoCatalogueinfo) {
            this.shiping(videoCatalogueinfo.sectionId, videoCatalogueinfo.percentage, videoCatalogueinfo)
            return
          }
          console.log(this.videoCatalogue[0], 111)
          this.shiping(this.videoCatalogue[0].sectionId, this.videoCatalogue[0].percentage, this.videoCatalogue[0])

        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          })
        }
      })
      return
      selecVideoList(chapterName).then(res => {
        if (res.data.success === true) {
          this.videoCatalogue = res.data.data;
          // 默认播放第一小节
          // console.log("!!!!!!!!!!!!!!!!")
          // console.log(this.videoCatalogue)
          this.shiping(this.videoCatalogue[0].sectionId)
        } else {
          this.$message({
            type: "error",
            message: res.data.msg
          })
        }
      })

    },
    saveQJ (type = '') {
      saveQJ({
        specialFlag: type,
        sectionId: this.videoCatalogue[this.selecIndex].sectionId,
        watchTime: this.dp.video.currentTime
      }).then(res => {
        console.log(res, '保存学分')
        if (res.data.success === true) {
          selecVideoListByMajorId(this.$route.query.courseId).then(res => {
            if (res.data.success === true) {
              this.videoCatalogue = res.data.data;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              })
            }
          })
        }
      })
    },
    shiping (id, percentage, item) {

      if (this.info.courseType == 2) {
        getPlayInfo(item.playUrl).then(res => {
          let videoUrl = res.data.data;
          if (this.dp) {
            this.dp.switchVideo({
              // url: currentGoVoItem.aliPlayUrl,videoUrl.value
              url: videoUrl,
            });
            this.dp.seek(item.learnedTime || 0);
            this.dp.play();
          } else {
            this.dp = new DPlayer({
              container: document.getElementById('dplayer'),
              hotkey: false,
              autoplay: true,
              contextmenu: [],
              video: {
                url: videoUrl
              },
            });
            this.dp.seek(item.learnedTime || 0);
            this.dp.on('canplay', () => {
              console.log('canplay')
              listDictByUser(
                {
                  code: 'jxjy_speed1'
                }
              ).then(res => {
                let index = res.data.data[0].dictKey
                console.log(index)
                console.log(document.getElementsByClassName('dplayer-bar-wrap')[0])
                if (index == 0) {
                  if (document.getElementsByClassName('dplayer-bar-wrap')[0]) {
                    document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'none';
                  }
                } else {
                  document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'block';
                }
                if (item.percentage >= 99) {
                  document.getElementsByClassName('dplayer-bar-wrap')[0].style.display = 'block';
                } else {
                }
              })
            })
            this.dp.on('pause', (e) => {
              //暂停播放
              console.log(e, '播放暂停 ~~~');
              clearInterval(this.timer)
              this.saveQJ()
            });
            this.dp.on('play', (e) => {
              console.log(e, '播放开始 ~~~');
              clearInterval(this.timer)
              this.timer = setInterval(() => {
                this.saveQJ()
              }, 30000);
            });
            this.dp.on('timeupdate', (e) => {
              //进度条变化
              // console.log(e, '进度条变化', this.dp.video.currentTime)
            })
            this.dp.on('ended', (e) => {
              //进度条变化
              console.log(e, '播放结束', this.dp.video.currentTime)
              this.saveQJ(1)
              this.dp.seek(0);
              this.$nextTick(() => {
                let index1 = ''
                let itemi = ''
                this.videoCatalogue.forEach((item, index) => {
                  if ((index - 1) == this.selecIndex) {
                    index1 = index
                    itemi = item
                  }
                })
                if (index1) {
                  this.handleNodeClickTwo(itemi, index1)

                }
              })


            })
            this.dp.on('waiting', (e) => {
              //播放报错
              console.log(e, '播放报错')

            });
            this.dp.on('playing', (e) => {
              console.log('播放准备开始 ~~~');
              console.log(e, '播放准备开始')


            });
          }
        });

        return
      }
      var userId = getToken('userId')
      let obj = {
        userId: userId,
        classId: id,
      }
      listDictByUser(
        {
          code: 'jxjy_speed1'
        }
      ).then(res => {
        let index = res.data.data[0].dictKey
        console.log(index)
        let appkey = 'enNfMDAx';
        let userId2 = obj.userId;

        let classid = obj.classId;
        let Base64 = require('js-base64').Base64;
        let autoplay1 = Base64.encodeURI(1);       //自定播放
        let speed1 = Base64.encodeURI(index);          //是否能拖动进度条 0 是 不能 1 是可以
        if (percentage > 95) {
          speed1 = Base64.encodeURI(1);
        }

        let url = "http://api.share.zsjykj.net/CourseVideoEx.html?appkey=" + appkey + "&userid=" + userId2 + "&classid=" + classid + "&autoplay=" + autoplay1 + "&speed=" + speed1
        this.iframeUrl = url
      })


      // this.iframeUrl = CIDEOURL(obj)
      console.log(this.iframeUrl)
    },
  },
  mounted () {
    // this.shiping(this.$route.query.id)
    // console.log(this.$route.query.chapterName)
    // courseById(this.$route.query.courseId).then(res => {
    //   console.log(res, '课程资料')
    //   this.info = res.data.data
    // })
    this.open(this.$route.query.chapterName, this.$route.query.courseId)
    //
    this.location = this.$route.query.location;
    // 回到顶部
    let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrolltop > 0) {
      document.body.scrollTop = document.documentElement.scrollTop = scrolltop - scrolltop;
      // console.log("111111111111111111111111")
      // console.log(scrolltop)
    }


  },
  created () {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    // window.addEventListener('scroll', this.handleScroll, true);
  }
}
</script>
<style >
.dplayer-bar-wrap {
  display: none;
}
</style>
<style scoped>
.box_video {
  overflow: hidden;
  width: 100%;
}
.box_video_file {
  display: flex;
  justify-content: space-between;
  min-width: 1000px;
}
.box_video_shi {
  width: 888px;
  height: 500px;
  /* background-color: aqua; */
  /* flex-shrink: 0 */
}
.box_video_jian {
  /* width: 350px; */
  /* min-width: 260px; */
  /* flex: 1; */
  height: 600px;
  width: 30%;
  overflow: auto;
  background-color: #faf9f9;
  /* border-radius: 20px; */
  flex-shrink: 0;
}
.box_curriculum_title_1 {
  height: 55px;
  line-height: 55px;
  background: #faf9f9;
  border-bottom: 1px solid #d1d5db;
}
.box_video_mulu {
  margin: 50px 0;
  border: 1px solid #d1d5db;
}
.box_video_mulu_1 {
  padding: 0 20px;
}
.box_video_mulu_file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d1d5db;
  min-height: 50px;
  /* line-height: 50px; */
}
.xuanfu:hover {
  cursor: pointer;
  background-color: #ffd2bd;
  color: #eb5405;
}
/* 选中时 */
.selected {
  background-color: #ffd2bd;
  color: #eb5405;
}
.video-wrapper {
  /* max-width: 888px; */
  /* min-width: 600px; */
  /* width: 70%; */
  flex: 1;
  height: 600px;
  flex-shrink: 1;
}
</style>
